export default __webpack_public_path__ + "static/media/light-logo.358632f9.png";